import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";

export const AppSelectDropdownWhite = ({ apps = [], disabled }) => {
  const { selectedAPIKey, setSelectedAPIKey } = useContext(AppContext);

  const handleChange = (event) => {
    setSelectedAPIKey(event.target.value);
  };

  return (
    <FormControl
      variant="standard"
      disabled={disabled}
      sx={{
        m: 0,
        width: "100%",
        "& .MuiInputBase-root:before": { borderBottom: "1px solid #ffffff" },
        "& .MuiInputBase-root:hover:not(.Mui-disabled):before": { borderBottom: "1px solid #ffffff" },
        "& .MuiInputBase-root:after": { borderBottom: "none" },
        "& .MuiInputBase-root.Mui-disabled:before": { borderBottomStyle: "solid", borderColor: "rgba(255,255,255,0.3)" },
      }}
    >
      <InputLabel
        id="location-label"
        sx={{ color: "white", "&.Mui-focused": { color: "#ffffff" }, "&.Mui-disabled": { color: "rgba(255,255,255,0.4)" } }}
      >
        Select Location
      </InputLabel>
      <Select
        labelId="location-label"
        value={selectedAPIKey ?? ""}
        onChange={handleChange}
        sx={{
          textAlign: "left",
          color: "#ffffff",
          ".MuiSelect-icon": { color: "#ffffff" },
          "& .MuiInputBase-input": { color: "#ffffff" },
          "&.Mui-disabled .MuiSelect-icon": { color: "rgba(255,255,255,0.4)" },
          "&.Mui-disabled .MuiInputBase-input": { color: "rgba(255,255,255,0.4)", WebkitTextFillColor: "rgba(255,255,255,0.4)" },
        }}
        MenuProps={{ PaperProps: { sx: { backgroundColor: "black", color: "#ffffff" } } }}
      >
        {apps.map((app) => (
          <MenuItem key={app.ApiKey} value={app.ApiKey}>
            {app.AppName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
